import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container-eden py-32 text-center" data-testid="not-found-page">
      <p className="eyebrow">Erro 404</p>
      <h1 className="mt-6 text-4xl font-extrabold tracking-tight text-eden-text sm:text-5xl">Esta rua não existe no EDEN.</h1>
      <p className="mt-4 text-eden-secondary">A página que procuras foi movida ou nunca existiu.</p>
      <Link to="/" className="btn-secondary mt-10" data-testid="not-found-home-link">Voltar ao início</Link>
    </section>
  );
}
